import React, { useContext } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import AssuranceContext from "../../context/index";
import PolicyItem from "./policy";
import { useStyles } from "./dashboardStyles";

function Policies({ downloadFile, handleViewClick, onClickHandler }) {
  const {
    state: { policies },
    dispatch,
  } = useContext(AssuranceContext);

  return policies.map((item, index) => {
    return (
      <PolicyItem
        downloadFile={downloadFile}
        handleViewClick={handleViewClick}
        item={item}
        index={index}
        onClickHandler={onClickHandler}
        key={index}
      />
    );
  });
}

export default withStyles(useStyles, { withTheme: true })(Policies);
